import { Map as MGMap } from '@meteogroup/map-layers';
import { WeatherBroadcastingLayer } from '../../../src/maplayers/weather-broadcasting-layer';
import { WeatherBroadcast } from './types';

export const VoyWeatherBroadcastManager = new class extends EventTarget {
	private _layer: WeatherBroadcastingLayer | null = null;
	private _map: MGMap | null = null;
	private _selection: Set<number> = new Set();

	constructor() {
    	super();
		this._layer = new WeatherBroadcastingLayer();

		this.enterMode = this.enterMode.bind(this)
		this.exitMode = this.exitMode.bind(this)
		this.setSelection = this.setSelection.bind(this)
		this.assignMap = this.assignMap.bind(this)
	}

	get selection() {
		return this._selection;
	}

	enterMode(): void {
		if (!this._map) {
			return
		}
		
		this._layer?.enterVesselSelectionMode(this._map);
	}

	exitMode(): void {
		if (!this._map || !this._layer) {
			return
		}
	
		this._layer.exitVesselSelectionMode(Array.from(this._selection));
		this._clearSelection();
	}

	setSelection(deselectedImos: number[], selectedImos: number[]) {
		for (const imo of deselectedImos) {
			this._selection.delete(imo);
		}
		for (const imo of selectedImos) {
			this._selection.add(imo);
		}

		this.dispatchEvent(new CustomEvent(WeatherBroadcast.SelectionUpdated, {detail: {
			deselectedImos,
			selectedImos
		}}));
	}

	assignMap(map: MGMap): void {
		this._map = map;
	}

	private _clearSelection() {
		this.dispatchEvent(new CustomEvent(WeatherBroadcast.SelectionUpdated, {detail: {
			deselectedImos: Array.from(this._selection),
			selectedImos: []
		}}));
		this._selection.clear();
	}
}
